import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardMedia from '@material-ui/core/CardMedia';

import { Grid } from '@material-ui/core';

import tab1Img1 from './imgs/Tab1Figure1.jpg';
import tab1Img2 from './imgs/Tab1Figure2.png';

import tab2Img1 from './imgs/Tab2Figure1.jpg';
import tab2Img2 from './imgs/Tab2Figure2.jpg';
import tab2Img3 from './imgs/Tab2Figure3.png';
import tab2Img4 from './imgs/Tab2Figure4.jpg';
import tab2Img5 from './imgs/Tab2Figure5.png';
import tab2Img6 from './imgs/Tab2Figure6.png';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  paper: {
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
  imgWidth: {
    maxWidth:"100%"
  },
  aLink : {
    textDecoration: 'none',
    color : "#3f51b5"
  }
}));

function AboutWiltComponent() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <AppBar position="static" color="default">
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
          >
            <Tab label="What is Watermelon wilt?" {...a11yProps(0)} />
            <Tab label="Identifiying the pathogen" {...a11yProps(1)} />
          </Tabs>
        </AppBar>
        <TabPanel value={value} index={0}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <p>
                It is a soilborne watermelon disease caused by the fungus <i>Fusarium oxysporum f. sp. niveum </i> (FON). FON is believed to only infect watermelon and currently there are 4 identified races of this pathogen that typically vary in their disease-causing ability (virulence) on watermelon cultivars.
              </p>
              <p>
                The pathogen infects watermelon plants primarily through the roots and can cause plant death within 1 to 2 days. Yield reductions up to 100% can occur from this disease and the canopy gaps left by the dead plants can lead to yield limiting weed infestations.
              </p>
            </Grid>
            <Grid item xs={6}>
              <Card className={classes.root}>
                <CardActionArea>
                  <CardMedia component="img" alt="" image={tab1Img1}/>
                  <CardContent>
                    <Typography variant="body2" color="textSecondary" component="p">Figure 1. It is a soilborne watermelon disease caused by the fungus Fusarium oxysporum f. sp. niveum (FON).</Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
            <Grid item xs={6}>
              <Card className={classes.root}>
                <CardActionArea>
                  <CardMedia component="img" alt="" image={tab1Img2}/>
                  <CardContent>
                    <Typography variant="body2" color="textSecondary" component="p">Figure 2. The canopy gaps left by the dead plants can lead to yield limiting weed infestations.</Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
            <Grid>
              <p>
                Further information can be found here 
                <a rel="noopener noreferrer" href="https://edis.ifas.ufl.edu/pdffiles/PP/PP35200.pdf" target="_blank" className={classes.aLink}> UF IFAS EDIS </a> 
                and
                <a rel="noopener noreferrer" href="http://www.plantmanagementnetwork.org/edcenter/seminars/Cucurbits/FusariumWilt/" target="_blank" className={classes.aLink}> Plant Health Exchange </a>
              </p>
            </Grid>
          </Grid>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <p>
              Typically, confirmation of Fusarium wilt (FW) in the field is not possible, but there are some key symptoms that indicate the disease is present. Wilting starts with individual plant runners (Fig. 1) that eventually leads to wilting of the whole plant (Fig. 2) followed by death (Fig. 3). This wilting symptom can sometimes be distinguished from other wilting problems (e.g. drought stress) by looking for discoloration of the vascular tissue on the runners or stems. The most prevalent vascular discoloration occurs near the soil line on stems cut longitudinally. In rare cases, it is possible to see white to pink fungal growth emerging from dead (necrotic) plant tissue (Fig. 4). Environment and host resistance play an important part in Fusarium wilt disease development and symptom expression. In some cases, plants may only be stunted without obvious wilt symptoms while others may die within 1 to 2 days of noticing runner wilting.
              </p>
            </Grid>
            <Grid item xs={6}>
              <Card className={classes.root}>
                <CardActionArea>
                  <CardMedia component="img" alt="" image={tab2Img1}/>
                  <CardContent>
                    <Typography variant="body2" color="textSecondary" component="p">Figure 1. Image of disease watermelon runners</Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
            <Grid item xs={6}>
             <Card className={classes.root}>
                <CardActionArea>
                  <CardMedia component="img" alt="" image={tab2Img2}/>
                  <CardContent>
                    <Typography variant="body2" color="textSecondary" component="p">Figure 2. Image of wilted but not dead watermelon plant.</Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
            <Grid item xs={6}>
              <Card className={classes.root}>
                <CardActionArea>
                  <CardMedia component="img" alt="" image={tab2Img3}/>
                  <CardContent>
                    <Typography variant="body2" color="textSecondary" component="p">Figure 3.</Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
            <Grid item xs={6}>
              <Card className={classes.root}>
                <CardActionArea>
                  <CardMedia component="img" alt="" image={tab2Img4}/>
                  <CardContent>
                    <Typography variant="body2" color="textSecondary" component="p">Figure 4. The most prevalent vascular discoloration occurs near the soil line on stems cut longitudinally.</Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
            <Grid item xs={12}>
              <p>
                Laboratory procedures are needed to confirm the pathogen presence in the host. This requires sterilize plant tissue and watching for fungal growth from the vascular tissue (Fig. 4). This pathogen can be further identified through its spores, however in order to determine the species PCR based techniques are needed. Race identification currently takes 1 to 3 months to complete and requires inoculations onto a specific set of cultivars known as differentials. Research is being done to identify pathogenicity factors of this pathogen through molecular methods that will require less time and cost.
              </p>
            </Grid>
            <Grid item xs={6}>
              <Card className={classes.root}>
                <CardActionArea>
                  <CardMedia component="img" alt="" image={tab2Img5}/>
                  <CardContent>
                    <Typography variant="body2" color="textSecondary" component="p">Figure 5. In rare cases, it is possible to see white to pink fungal growth emerging from dead (necrotic) plant tissue” and “This requires sterilize plant tissue and watching for fungal growth from the vascular tissue.”</Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
            <Grid item xs={6}>
              <Card className={classes.root}>
                <CardActionArea>
                  <CardMedia component="img" alt="" image={tab2Img6}/>
                  <CardContent>
                    <Typography variant="body2" color="textSecondary" component="p">Figure 6. Race identification currently takes 1 to 3 months to complete and requires inoculations onto a specific set of cultivars known as differentials.</Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
            <Grid item xs={12}>
              <p>
                Further information about FW identification and pathogen identification can be found in this <a rel="noopener noreferrer" href="https://edis.ifas.ufl.edu/pdffiles/PP/PP35200.pdf" target="_blank" className={classes.aLink}>link</a>.
             </p>
            </Grid>
          </Grid>
        </TabPanel>
      </Paper>
    </div>
  );
}

export default {
    routeProps: {
        path: '/aboutwilt',
        component: AboutWiltComponent
    },
    name: 'About Watermelon Wilt',
}
